import Moment from 'moment'
import * as Redux from 'redux'
import * as IsActive from '../../components/is_active'
import * as Modal from '../../components/modal'
import * as Sortable from '../../components/sortable'
import * as Constants from './constants'
import * as Types from './types'

const normalizeTypes: Sortable.TypeNormalizer<Types.FilterGroup> =
  (payload: Types.FilterGroup[]): Sortable.SortableData<Types.FilterGroup> => {
  return payload.map((fg: Types.FilterGroup) => ({
    ...fg,
    created_datetime: Moment(fg.created),
    updated_datetime: Moment(fg.updated),
  }))
}

const reducerEvent: Sortable.ReducerEvent<Types.FilterGroup> = {
  defaultSort: {field: 'updated_datetime', dir: 'desc'},
  normalizer: normalizeTypes,
  requestEvent: Constants.FETCH_FILTER_GROUPS,
}

const addFilterModalReducerEvent: Modal.ReducerEvent<Types.AddFilterGroupData> = {
  initializeState: () => ({name: '', tags: ''}),
  requestEvent: Constants.ADD_FILTER_GROUP,
}

const emptyViewState: Types.FilterGroupsViewState = {
  filter: IsActive.FILTER_STATUS_ALL,
  isLoading: false,
  sort: [],
}

export const reducer = Redux.combineReducers({
  data: IsActive.chainedReducer(Sortable.stateReducer(reducerEvent), Constants.UPDATE_FILTER_GROUP_INLINE),
  modalAddFilterGroup: Modal.reducer(addFilterModalReducerEvent),
  view: IsActive.filterReducer(
    Sortable.viewReducer(reducerEvent), Constants.FETCH_FILTER_GROUPS, emptyViewState),
})



// WEBPACK FOOTER //
// ./src/pages/filter-groups/reducer.ts